import { useRef, useState } from "react";
import { useEffect } from "react";
import {
  Card,
  Row,
  Col,
  CardBody,
  Button,
  Label,
  Input,
  FormGroup,
  // Tooltip,
} from "reactstrap";
import PortFolioService from "../../services/PortfolioService";
import Loading from "../Loading/Loading";
import "./Curriculum.scss";

// Import Advert component for Google ads
import Advert from "../Advert/Advert";

import Switch from "react-switch";
import CommonButton from "../CommonButton/CommonButton";
import swal from "sweetalert";
import { CommonMessages } from "../../constants/CommonMessages";
import { useSelector, useDispatch } from "react-redux";
import { setLanguage as setAppLanguage } from "../../reducers/LanguageReducer";
import { useHistory } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import { faUpload, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Storage from "../../services/Storage";

// Import button icons
import saveIcon from "../../assets/images/buttons/save.png";
import cancelIcon from "../../assets/images/buttons/cancel.png";

const API_URL = process.env.REACT_APP_API_URL;

const CurriculumUpload = () => {
  const dispatch = useDispatch();
  let userData = useSelector((state) => state.UserReducer.userObj);
  const lang = useSelector((state) => state.LanguageReducer.current) || "en";
  let history = useHistory();

  const [IELTS, setIELTS] = useState();
  const [TOEFL, setTOEFL] = useState();
  const [GRE, setGRE] = useState();
  const [GMAT, setGMAT] = useState();
  const [DET, setDET] = useState();
  const [user, setUser] = useState(userData);

  const [recommendation, setRecommendation] = useState(null);
  const [purpose, setPurpose] = useState(null);
  const [internship, setInternship] = useState(null);
  const [educational, setEducational] = useState(null);
  const [resume, setResume] = useState(null);

  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState(false);
  const hasFetchedRef = useRef(false);
  const isLangFirstRunRef = useRef(true);

  const [uploadedFile, setUploadedFile] = useState({
    IELTS: null,
    TOEFL: null,
    GRE: null,
    GMAT: null,
    DET: null,
    recommendation: null,
    purpose: null,
    internship: null,
    educational: null,
    resume: null,
  });
  const [uploadedFileName, setUploadedFileName] = useState({
    IELTS: "",
    TOEFL: "",
    GRE: "",
    GMAT: "",
    DET: "",
    recommendation: "",
    purpose: "",
    internship: "",
    educational: "",
    resume: "",
  });

  // Localized alert messages
  const alerts = {
    en: {
      fileUploadedSuccess: "File Uploaded Successfully.",
      recommendation: "Please select letter of recommendation.",
      purpose: "Please select statement of purpose.",
      internship: "Please select research papers / internships.",
      educational: "Please select all education transcript.",
      resume: "Please select cv or resume.",
    },
    es: {
      fileUploadedSuccess: "Archivo subido correctamente.",
      recommendation: "Por favor selecciona la carta de recomendación.",
      purpose: "Por favor selecciona la declaración de propósito.",
      internship: "Por favor selecciona trabajos de investigación / pasantías.",
      educational: "Por favor selecciona todas las transcripciones educativas.",
      resume: "Por favor selecciona CV o currículum.",
    },
  };
  const tAlert = (key) => (alerts[lang] || alerts.en)[key];

  // const [tooltipOpenUpload, setTooltipOpenUpload] = useState({
  //   IELTS: false,
  //   TOEFL: false,
  //   GRE: false,
  //   GMAT: false,
  //   recommendation: false,
  //   purpose: false,
  //   internship: false,
  //   educational: false,
  //   resume: false,
  // });

  // const [tooltipOpenPreview, setTooltipOpenPreview] = useState({
  //   IELTS: false,
  //   TOEFL: false,
  //   GRE: false,
  //   GMAT: false,
  //   recommendation: false,
  //   purpose: false,
  //   internship: false,
  //   educational: false,
  //   resume: false,
  // });

  // const toggleTooltipUpload = (exam) => {
  //   setTooltipOpenUpload((prevState) => ({
  //     ...prevState,
  //     [exam]: !prevState[exam],
  //   }));
  // };

  // const toggleTooltipPreview = (exam) => {
  //   setTooltipOpenPreview((prevState) => ({
  //     ...prevState,
  //     [exam]: !prevState[exam],
  //   }));
  // };

  const [studentValue, setStudentValue] = useState("");

  useEffect(() => {
    const storedValue = localStorage.getItem("studentValue");
    if (storedValue) {
      setStudentValue(storedValue);
    }
  }, []);

  // Keep local toggle in sync with global language
  useEffect(() => {
    setLanguage(lang === "es");
  }, [lang]);

  const handleFileUpload = async (exam, documentType) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".pdf,.doc,.docx,.jpg,.jpeg,.png";

    input.onchange = async (e) => {
      const file = e.target.files[0];
      const fileURL = URL.createObjectURL(file);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("user_id", user?.id);
      formData.append("type", documentType);
      let token = Storage.getTokenInCookie() ? Storage.getTokenInCookie() : "";
      formData.append("token", token); // Append additional data like token

      setLoading(true);
      try {
        const headers = {
          "x-authorization": `Bearer ${token}`,
        };
        const response = await fetch(
          `${API_URL}/api/student/attachment_curriculum/`,
          {
            method: "POST",
            headers,
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setLoading(false);
        console.log("Response from server:", data);
        const uploadedFileURL = data?.Status?.file_url;

        swal({
          text: tAlert("fileUploadedSuccess"),
          icon: "success",
          buttons: {
            OK: true,
          },
          closeOnClickOutside: false,
        });

        setUploadedFile({ ...uploadedFile, [exam]: uploadedFileURL });
        setUploadedFileName({ ...uploadedFileName, [exam]: file.name });
      } catch (error) {
        setLoading(false);
        console.error("Error from the service", error);
      }
    };

    input.click();
  };

  const handleRemoveFile = (exam) => {
    setUploadedFile({ ...uploadedFile, [exam]: null });
    setUploadedFileName({ ...uploadedFileName, [exam]: "" });
  };

  const handleRecommendationChange = (e) => {
    setRecommendation(e.target.value);
    if (e.target.value === "No") {
      handleRemoveFile("recommendation");
    }
  };

  const handlePurposeChange = (e) => {
    setPurpose(e.target.value);
    if (e.target.value === "No") {
      handleRemoveFile("purpose");
    }
  };

  const handleInternshipChange = (e) => {
    setInternship(e.target.value);
    if (e.target.value === "No") {
      handleRemoveFile("internship");
    }
  };

  const handleEducationalChange = (e) => {
    setEducational(e.target.value);
    if (e.target.value === "No") {
      handleRemoveFile("educational");
    }
  };

  const handleResumeChange = (e) => {
    setResume(e.target.value);
    if (e.target.value === "No") {
      handleRemoveFile("resume");
    }
  };

  const renderFileUpload = (exam, score, setScore, documentType) => (
    <FormGroup className="position-relative">
      <Row>
        <Col xs="12" lg="6">
          <Label for={`${exam}Score`} className="labelBold">
            {language === true ? `${exam} Puntaje` : `${exam} Score`}
          </Label>
          <Input
            required
            type="number"
            name={`${exam}Score`}
            id={`${exam}Score`}
            placeholder={
              language === true
                ? `Entra tu ${exam} puntaje`
                : `Enter your ${exam} score`
            }
            value={score}
            onChange={(e) => setScore(e.target.value)}
            autoComplete="off"
            maxLength={5}
            className="form-input"
          />
        </Col>
        <Col xs="12" lg="6">
          <Label for={`upload${exam}`} className="labelBold">
            {language === true
              ? `Subir ${exam} Tarjeta de puntuación`
              : `Upload ${exam} Score Card`}
          </Label>
          <div className={`upload-section ${!uploadedFile[exam] ? "empty" : ""}`}>
            {!uploadedFile[exam] && (
              <div
                id={`uploadIcon-${exam}`}
                onClick={() => handleFileUpload(exam, documentType)}
                className="upload-button"
              >
                <FontAwesomeIcon icon={faUpload} size="lg" />
              </div>
            )}
            {uploadedFile[exam] && (
              <>
                <span className="file-name">{uploadedFileName[exam]}</span>
                <a
                  href={uploadedFile[exam]}
                  target="_blank"
                  rel="noopener noreferrer"
                  id={`previewIcon-${exam}`}
                  className="preview-button"
                >
                  <FontAwesomeIcon icon={faEye} size="lg" />
                </a>
                <div
                  onClick={() => handleRemoveFile(exam)}
                  className="remove-button"
                >
                  <FontAwesomeIcon icon={faTimes} size="lg" />
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
    </FormGroup>
  );

  const handleLanguage = (checked) => {
    const selectedLanguage = checked ? "es" : "en";
    setLanguage(checked);
    dispatch(setAppLanguage(selectedLanguage));
    // Re-fetch handled by language effect
  };

  // Helper function to extract filename from URL
  const extractFileNameFromURL = (url) => {
    if (!url) return "";
    try {
      const urlParts = url.split("/");
      let fileName = urlParts[urlParts.length - 1];

      // Remove any query parameters
      fileName = fileName.split("?")[0];

      // Decode URI components (handles encoded characters)
      fileName = decodeURIComponent(fileName);

      // If filename is too generic or unclear, provide a meaningful name
      const genericNames = ["document", "file", "upload", "image"];
      const baseName = fileName.toLowerCase().split(".")[0];

      if (genericNames.includes(baseName) || fileName.length < 3) {
        // Extract document type from the URL path if possible
        const pathParts = url.split("/");
        const possibleType = pathParts.find(
          (part) =>
            part.includes("scorecard") ||
            part.includes("document") ||
            part.includes("curriculum")
        );

        if (possibleType) {
          return `Uploaded Document.${fileName.split(".").pop() || "pdf"}`;
        }
        return `Uploaded File.${fileName.split(".").pop() || "pdf"}`;
      }

      return fileName;
    } catch (error) {
      console.error("Error extracting filename:", error);
      return "Uploaded Document";
    }
  };

  useEffect(() => {
    if (!hasFetchedRef.current) {
      hasFetchedRef.current = true;
      getCurriculumUpload();
    }
  }, []);

  // Re-fetch when language changes (skip initial mount)
  useEffect(() => {
    if (isLangFirstRunRef.current) {
      isLangFirstRunRef.current = false;
      return;
    }
    getCurriculumUpload();
  }, [lang]);

  const getCurriculumUpload = () => {
    setLoading(true);
    PortFolioService.getCurriculumUpload()
      .then((data) => {
        const curriculums = data?.data || {};
        setIELTS(curriculums?.ielts_score || "");
        setTOEFL(curriculums?.toefl_score || "");
        setGRE(curriculums?.gre_score || "");
        setGMAT(curriculums?.gmat_score || "");
        setDET(curriculums?.det_score || "");
        setRecommendation(curriculums?.letter_of_recommendation || "");
        setPurpose(curriculums?.statement_of_purpose || "");
        setInternship(curriculums?.research_papers_internships || "");
        setEducational(curriculums?.all_education_transcript || "");
        setResume(curriculums?.cv_resume || "");

        // Set uploaded files
        const fileData = {
          IELTS: curriculums?.ielts_scorecard || "",
          TOEFL: curriculums?.toefl_scorecard || "",
          GRE: curriculums?.gre_scorecard || "",
          GMAT: curriculums?.gmat_scorecard || "",
          DET: curriculums?.det_scorecard || "",
          recommendation: curriculums?.lor_document || "",
          purpose: curriculums?.sop_document || "",
          internship: curriculums?.rpi_document || "",
          educational: curriculums?.aet_document || "",
          resume: curriculums?.cv_resume_document || "",
        };

        setUploadedFile(fileData);

        // Extract and set file names from URLs
        const fileNames = {
          IELTS: extractFileNameFromURL(curriculums?.ielts_scorecard),
          TOEFL: extractFileNameFromURL(curriculums?.toefl_scorecard),
          GRE: extractFileNameFromURL(curriculums?.gre_scorecard),
          GMAT: extractFileNameFromURL(curriculums?.gmat_scorecard),
          DET: extractFileNameFromURL(curriculums?.det_scorecard),
          recommendation: extractFileNameFromURL(curriculums?.lor_document),
          purpose: extractFileNameFromURL(curriculums?.sop_document),
          internship: extractFileNameFromURL(curriculums?.rpi_document),
          educational: extractFileNameFromURL(curriculums?.aet_document),
          resume: extractFileNameFromURL(curriculums?.cv_resume_document),
        };

        setUploadedFileName(fileNames);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("error from the service", error);
      });
  };

  const handleCurriculumSubmit = () => {
    if (!recommendation) {
      swal("", tAlert("recommendation"), "error");
      return;
    }
    if (studentValue === "Graduate" && !purpose) {
      swal("", tAlert("purpose"), "error");
      return;
    }
    if (studentValue === "Graduate" && !internship) {
      swal("", tAlert("internship"), "error");
      return;
    }
    if (!educational) {
      swal("", tAlert("educational"), "error");
      return;
    }
    if (!resume) {
      swal("", tAlert("resume"), "error");
      return;
    }
    const formData = new FormData();

    formData.append("user_id", user?.id);
    if (IELTS) {
      formData.append("ielts_score", IELTS);
    }

    if (uploadedFile?.IELTS) {
      formData.append("ielts_scorecard", uploadedFile?.IELTS);
    }

    if (TOEFL) {
      formData.append("toefl_score", TOEFL);
    }

    if (uploadedFile?.TOEFL) {
      formData.append("toefl_scorecard", uploadedFile?.TOEFL);
    }

    if (GRE) {
      formData.append("gre_score", GRE);
    }

    if (uploadedFile?.GRE) {
      formData.append("gre_scorecard", uploadedFile?.GRE);
    }

    if (GMAT) {
      formData.append("gmat_score", GMAT);
    }

    if (uploadedFile?.GMAT) {
      formData.append("gmat_scorecard", uploadedFile?.GMAT);
    }

    if (DET) {
      formData.append("det_score", DET);
    }

    if (uploadedFile?.DET) {
      formData.append("det_scorecard", uploadedFile?.DET);
    }

    if (recommendation) {
      formData.append("letter_of_recommendation", recommendation);
    }

    if (uploadedFile?.recommendation) {
      formData.append("lor_document", uploadedFile?.recommendation);
    }

    if (purpose) {
      formData.append("statement_of_purpose", purpose);
    }

    if (uploadedFile?.purpose) {
      formData.append("sop_document", uploadedFile?.purpose);
    }

    if (internship) {
      formData.append("research_papers_internships", internship);
    }

    if (uploadedFile?.internship) {
      formData.append("rpi_document", uploadedFile?.internship);
    }

    if (educational) {
      formData.append("all_education_transcript", educational);
    }

    if (uploadedFile?.educational) {
      formData.append("aet_document", uploadedFile?.educational);
    }

    if (resume) {
      formData.append("cv_resume", resume);
    }

    if (uploadedFile?.resume) {
      formData.append("cv_resume_document", uploadedFile?.resume);
    }

    setLoading(true);

    PortFolioService.saveCurriculumUpload(formData)
      .then((data) => {
        if (data.status === 200) {
          setLoading(false);
          swal("", CommonMessages.curriculumSaved, "success");
          if (user) {
            user.filled_curriculum = true;
            localStorage.setItem("user", JSON.stringify(user));
          } else {
            console.error("User not found in localStorage");
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("error from the service", error);
        if (error?.response?.status === 400) {
          swal("", error?.response?.data?.message, "error");
        } else if (error?.response?.status === 500) {
          swal("", error?.response?.data?.message, "error");
        }
      });
  };

  return (
    <div className="curriculum-page">
      <div className="curriculum-ad-header">
        <div className="header-content">
          <div className="ad-section-centered">
            <Advert />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="curriculum-content">
        <div className="container-fluid">
          <div className="curriculum-container">
            <Row>
              <Col lg="12" className="mx-auto">
                <div className="curriculum-card">
                  <div className="card-body">
                    {/* Title and Toggle Section */}
                    <div className="title-section">
                      <h1 className="title-main">{lang === "es" ? "Mi plan de estudios" : "My Curriculum"}</h1>
                      {/* <Switch
                        onChange={handleLanguage}
                        checked={language}
                        width={52}
                        height={24}
                        handleDiameter={18}
                        onColor="#28131A"
                        offColor="#049804"
                        uncheckedIcon={
                          <div className="switchIncon uncheckIcon">EN</div>
                        }
                        checkedIcon={
                          <div className="switchIncon checkIcon">ES</div>
                        }
                        className="langSwitch"
                      /> */}
                    </div>
                    {loading ? (
                      <div className="loading-container">
                        <Loading />
                      </div>
                    ) : (
                      <>
                        <Row>
                          <Col xs="12" lg="6">
                            {renderFileUpload(
                              "IELTS",
                              IELTS,
                              setIELTS,
                              "ielts_scorecard"
                            )}
                          </Col>
                          <Col xs="12" lg="6">
                            {renderFileUpload(
                              "TOEFL",
                              TOEFL,
                              setTOEFL,
                              "toefl_scorecard"
                            )}
                          </Col>
                          {studentValue === "Graduate" && (
                            <>
                              <Col xs="12" lg="6">
                                {renderFileUpload(
                                  "GRE",
                                  GRE,
                                  setGRE,
                                  "gre_scorecard"
                                )}
                              </Col>
                              <Col xs="12" lg="6">
                                {renderFileUpload(
                                  "GMAT",
                                  GMAT,
                                  setGMAT,
                                  "gmat_scorecard"
                                )}
                              </Col>
                            </>
                          )}
                          <Col xs="12" lg="6">
                            {renderFileUpload(
                              "DET",
                              DET,
                              setDET,
                              "det_scorecard"
                            )}
                          </Col>
                          <Col xs="12" lg="6" />
                          <Col xs="12" lg="6">
                            <Row>
                              <Col lg={recommendation === "Yes" ? "6" : "12"}>
                                <FormGroup className="position-relative">
                                  <Label
                                    className="labelBold"
                                    style={{ marginBottom: "20px" }}
                                  >
                                    {language === true
                                      ? "Carta de recomendación"
                                      : "Letter of Recommendation"}
                                  </Label>
                                  <div className="radio-group">
                                    <FormGroup
                                      check
                                      inline
                                      className="radio-item"
                                    >
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name="recommendation"
                                          value="Yes"
                                          checked={recommendation === "Yes"}
                                          onChange={handleRecommendationChange}
                                        />{" "}
                                        {language === true ? "Sí" : "Yes"}
                                      </Label>
                                    </FormGroup>
                                    <FormGroup
                                      check
                                      inline
                                      className="radio-item"
                                    >
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name="recommendation"
                                          value="No"
                                          checked={recommendation === "No"}
                                          onChange={handleRecommendationChange}
                                        />{" "}
                                        {language === true ? "No" : "No"}
                                      </Label>
                                    </FormGroup>
                                  </div>
                                </FormGroup>
                              </Col>

                              {recommendation === "Yes" && (
                                <Col xs="12" lg="6">
                                  <FormGroup className="position-relative">
                                    <Label
                                      for="fileUpload"
                                      className="labelBold"
                                    >
                                      {language === true
                                        ? "Subir carta de recomendación"
                                        : "Upload Letter of Recommendation"}
                                    </Label>
                                    <div className="upload-section">
                                      {!uploadedFile["recommendation"] && (
                                        <div
                                          id={`uploadIcon-recommendation`}
                                          onClick={() =>
                                            handleFileUpload(
                                              "recommendation",
                                              "lor_document"
                                            )
                                          }
                                          className="upload-button"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUpload}
                                            size="lg"
                                          />
                                        </div>
                                      )}
                                      {uploadedFile["recommendation"] && (
                                        <>
                                          <span className="file-name">
                                            {uploadedFileName["recommendation"]}
                                          </span>
                                          <a
                                            href={
                                              uploadedFile["recommendation"]
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            id={`previewIcon-recommendation`}
                                            className="preview-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faEye}
                                              size="lg"
                                            />
                                          </a>
                                          <div
                                            onClick={() =>
                                              handleRemoveFile("recommendation")
                                            }
                                            className="remove-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faTimes}
                                              size="lg"
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>
                          </Col>
                          {studentValue === "Graduate" && (
                            <Col xs="12" lg="6">
                              <Row>
                                <Col lg={purpose === "Yes" ? "6" : "12"}>
                                  <FormGroup className="position-relative">
                                    <Label
                                      className="labelBold"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      {language === true
                                        ? "Declaración de propósito"
                                        : "Statement of Purpose"}
                                    </Label>
                                    <div className="radio-group">
                                      <FormGroup
                                        check
                                        inline
                                        className="radio-item"
                                      >
                                        <Label check>
                                          <Input
                                            type="radio"
                                            name="purpose"
                                            value="Yes"
                                            checked={purpose === "Yes"}
                                            onChange={handlePurposeChange}
                                          />{" "}
                                          {language === true ? "Sí" : "Yes"}
                                        </Label>
                                      </FormGroup>
                                      <FormGroup
                                        check
                                        inline
                                        className="radio-item"
                                      >
                                        <Label check>
                                          <Input
                                            type="radio"
                                            name="purpose"
                                            value="No"
                                            checked={purpose === "No"}
                                            onChange={handlePurposeChange}
                                          />{" "}
                                          {language === true ? "No" : "No"}
                                        </Label>
                                      </FormGroup>
                                    </div>
                                  </FormGroup>
                                </Col>
                                {purpose === "Yes" && (
                                  <Col xs="12" lg="6">
                                    <FormGroup className="position-relative">
                                      <Label
                                        for="fileUpload"
                                        className="labelBold"
                                      >
                                        {language === true
                                          ? "Cargar declaración de propósito"
                                          : "Upload Statement of Purpose"}
                                      </Label>
                                      <div className="upload-section">
                                        {!uploadedFile["purpose"] && (
                                          <div
                                            id={`uploadIcon-purpose`}
                                            onClick={() =>
                                              handleFileUpload(
                                                "purpose",
                                                "sop_document"
                                              )
                                            }
                                            className="upload-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faUpload}
                                              size="lg"
                                            />
                                          </div>
                                        )}
                                        {uploadedFile["purpose"] && (
                                          <>
                                            <span className="file-name">
                                              {uploadedFileName["purpose"]}
                                            </span>
                                            <a
                                              href={uploadedFile["purpose"]}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              id={`previewIcon-purpose`}
                                              className="preview-button"
                                            >
                                              <FontAwesomeIcon
                                                icon={faEye}
                                                size="lg"
                                              />
                                            </a>
                                            <div
                                              onClick={() =>
                                                handleRemoveFile("purpose")
                                              }
                                              className="remove-button"
                                            >
                                              <FontAwesomeIcon
                                                icon={faTimes}
                                                size="lg"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          )}
                        </Row>

                        <Row>
                          {studentValue === "Graduate" && (
                            <Col xs="12" lg="6">
                              <Row>
                                <Col lg={internship === "Yes" ? "6" : "12"}>
                                  <FormGroup className="position-relative">
                                    <Label
                                      className="labelBold"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      {language === true
                                        ? "Trabajos de investigación publicados/pasantías"
                                        : "Published Research Papers / Internships"}
                                    </Label>
                                    <div className="radio-group">
                                      <FormGroup
                                        check
                                        inline
                                        className="radio-item"
                                      >
                                        <Label check>
                                          <Input
                                            type="radio"
                                            name="internship"
                                            value="Yes"
                                            checked={internship === "Yes"}
                                            onChange={handleInternshipChange}
                                          />{" "}
                                          {language === true ? "Sí" : "Yes"}
                                        </Label>
                                      </FormGroup>
                                      <FormGroup
                                        check
                                        inline
                                        className="radio-item"
                                      >
                                        <Label check>
                                          <Input
                                            type="radio"
                                            name="internship"
                                            value="No"
                                            checked={internship === "No"}
                                            onChange={handleInternshipChange}
                                          />{" "}
                                          {language === true ? "No" : "No"}
                                        </Label>
                                      </FormGroup>
                                    </div>
                                  </FormGroup>
                                </Col>
                                {internship === "Yes" && (
                                  <Col xs="12" lg="6">
                                    <FormGroup className="position-relative">
                                      <Label
                                        for="fileUpload"
                                        className="labelBold"
                                      >
                                        {language === true
                                          ? "Cargar trabajos de investigación publicados/pasantías"
                                          : "Upload Published Research Papers / Internships"}
                                      </Label>
                                      <div className="upload-section">
                                        {!uploadedFile["internship"] && (
                                          <div
                                            id={`uploadIcon-internship`}
                                            onClick={() =>
                                              handleFileUpload(
                                                "internship",
                                                "rpi_document"
                                              )
                                            }
                                            className="upload-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faUpload}
                                              size="lg"
                                            />
                                          </div>
                                        )}
                                        {uploadedFile["internship"] && (
                                          <>
                                            <span className="file-name">
                                              {uploadedFileName["internship"]}
                                            </span>
                                            <a
                                              href={uploadedFile["internship"]}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              id={`previewIcon-internship`}
                                              className="preview-button"
                                            >
                                              <FontAwesomeIcon
                                                icon={faEye}
                                                size="lg"
                                              />
                                            </a>
                                            <div
                                              onClick={() =>
                                                handleRemoveFile("internship")
                                              }
                                              className="remove-button"
                                            >
                                              <FontAwesomeIcon
                                                icon={faTimes}
                                                size="lg"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          )}
                          <Col xs="12" lg="6">
                            <Row>
                              <Col lg={educational === "Yes" ? "6" : "12"}>
                                <FormGroup className="position-relative">
                                  <Label
                                    className="labelBold"
                                    style={{ marginBottom: "20px" }}
                                  >
                                    {language === true
                                      ? "Todas las transcripciones educativas"
                                      : "All Education Transcripts"}
                                  </Label>
                                  <div className="radio-group">
                                    <FormGroup
                                      check
                                      inline
                                      className="radio-item"
                                    >
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name="educational"
                                          value="Yes"
                                          checked={educational === "Yes"}
                                          onChange={handleEducationalChange}
                                        />{" "}
                                        {language === true ? "Sí" : "Yes"}
                                      </Label>
                                    </FormGroup>
                                    <FormGroup
                                      check
                                      inline
                                      className="radio-item"
                                    >
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name="educational"
                                          value="No"
                                          checked={educational === "No"}
                                          onChange={handleEducationalChange}
                                        />{" "}
                                        {language === true ? "No" : "No"}
                                      </Label>
                                    </FormGroup>
                                  </div>
                                </FormGroup>
                              </Col>
                              {educational === "Yes" && (
                                <Col xs="12" lg="6">
                                  <FormGroup className="position-relative">
                                    <Label
                                      for="fileUpload"
                                      className="labelBold"
                                    >
                                      {language === true
                                        ? "Cargar todas las transcripciones educativas"
                                        : "Upload All Education Transcripts"}
                                    </Label>
                                    <div className="upload-section">
                                      {!uploadedFile["educational"] && (
                                        <div
                                          id={`uploadIcon-educational`}
                                          onClick={() =>
                                            handleFileUpload(
                                              "educational",
                                              "aet_document"
                                            )
                                          }
                                          className="upload-button"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUpload}
                                            size="lg"
                                          />
                                        </div>
                                      )}
                                      {uploadedFile["educational"] && (
                                        <>
                                          <span className="file-name">
                                            {uploadedFileName["educational"]}
                                          </span>
                                          <a
                                            href={uploadedFile["educational"]}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            id={`previewIcon-educational`}
                                            className="preview-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faEye}
                                              size="lg"
                                            />
                                          </a>
                                          <div
                                            onClick={() =>
                                              handleRemoveFile("educational")
                                            }
                                            className="remove-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faTimes}
                                              size="lg"
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" lg="6">
                            <Row>
                              <Col lg={resume === "Yes" ? "6" : "12"}>
                                <FormGroup className="position-relative">
                                  <Label
                                    className="labelBold"
                                    style={{ marginBottom: "20px" }}
                                  >
                                    {language === true
                                      ? "CV o currículum"
                                      : "CV or Resume"}
                                  </Label>
                                  <div className="radio-group">
                                    <FormGroup
                                      check
                                      inline
                                      className="radio-item"
                                    >
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name="resume"
                                          value="Yes"
                                          checked={resume === "Yes"}
                                          onChange={handleResumeChange}
                                        />{" "}
                                        {language === true ? "Sí" : "Yes"}
                                      </Label>
                                    </FormGroup>
                                    <FormGroup
                                      check
                                      inline
                                      className="radio-item"
                                    >
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name="resume"
                                          value="No"
                                          checked={resume === "No"}
                                          onChange={handleResumeChange}
                                        />{" "}
                                        {language === true ? "No" : "No"}
                                      </Label>
                                    </FormGroup>
                                  </div>
                                </FormGroup>
                              </Col>
                              {resume === "Yes" && (
                                <Col xs="12" lg="6">
                                  <FormGroup className="position-relative">
                                    <Label
                                      for="fileUpload"
                                      className="labelBold"
                                    >
                                      {language === true
                                        ? "Subir CV o Currículum"
                                        : "Upload CV or Resume"}
                                    </Label>
                                    <div className="upload-section">
                                      {!uploadedFile["resume"] && (
                                        <div
                                          id={`uploadIcon-resume`}
                                          onClick={() =>
                                            handleFileUpload(
                                              "resume",
                                              "cv_resume_document"
                                            )
                                          }
                                          className="upload-button"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUpload}
                                            size="lg"
                                          />
                                        </div>
                                      )}
                                      {/* <Tooltip
                                  placement="top"
                                  isOpen={tooltipOpenUpload["resume"]}
                                  target={`uploadIcon-resume`}
                                  toggle={() => toggleTooltipUpload("resume")}
                                >
                                  {language === true
                                    ? "Upload Document"
                                    : "Cargar documento"}
                                </Tooltip> */}
                                      {uploadedFile["resume"] && (
                                        <>
                                          <span className="file-name">
                                            {uploadedFileName["resume"]}
                                          </span>
                                          <a
                                            href={uploadedFile["resume"]}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            id={`previewIcon-resume`}
                                            className="preview-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faEye}
                                              size="lg"
                                            />
                                          </a>
                                          <div
                                            onClick={() =>
                                              handleRemoveFile("resume")
                                            }
                                            className="remove-button"
                                          >
                                            <FontAwesomeIcon
                                              icon={faTimes}
                                              size="lg"
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* Action Buttons Section */}
      <div className="button-row">
        <button
          className="action-btn cancel-btn"
          onClick={() => history.goBack()}
        >
          {lang === "es" ? "Atrás" : "Back"}
        </button>
        <button
          className="action-btn save-btn"
          onClick={() => handleCurriculumSubmit()}
        >
          <img src={saveIcon} alt="Save" className="btn-icon" />
          {lang === "es" ? "Guardar" : "Save"}
        </button>
      </div>
    </div>
  );
};

export default CurriculumUpload;
